import { ProposalDto } from '@gap/backend/app-services/proposal/models/ProposalDto';
import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils';
import { ServiceSelectionChangeListener } from './ProposalSectionServicesItem';

export default class ProposalSectionServicesStore {
   sp
   readonly serviceAgreementMap: ServiceAgreementMap = {}

   constructor(sp: ProposalSectionServicesStoreProps) {
      this.sp = sp
      // Initialise map with recommended services set to false
      this.serviceAgreementMap = (this.sp.proposal.step2 || [])
         .reduce<ServiceAgreementMap>((map, { serviceId, servicePriceType }) => ({
            ...map, [serviceId]: servicePriceType === 'agreed' ||
               this.sp.proposal.response?.includedOptionalServiceIds.includes(serviceId) || false
         }), {})
   }

   get agreedServices() {
      return (this.sp.proposal.step2 || []).filter(({ servicePriceType }) => servicePriceType === 'agreed')
   }

   get recommendedServices() {
      return (this.sp.proposal.step2 || []).filter(({ servicePriceType }) => servicePriceType === 'recommended')
   }

   onServiceAgreementChange: ServiceSelectionChangeListener = ({ serviceId, selected }) => {
      this.serviceAgreementMap[serviceId] = selected
      const includedOptionalServiceIds = this.recommendedServices.reduce<string[]>((ids, { serviceId }) => [
         ...ids,
         ...(this.serviceAgreementMap[serviceId] ? [serviceId] : [])
      ], [])
      this.sp.onServiceAgreementChange?.({ serviceAgreementMap: this.serviceAgreementMap, includedOptionalServiceIds })
   }
}

interface ProposalSectionServicesStoreProps {
   proposal: ProposalDto,
   onServiceAgreementChange?: ServiceAgreementChangeListener,
}

/** Maps serviceId to whether it selected */
type ServiceAgreementMap = Record<string, boolean>
export type ServiceAgreementChangeListener = (event: { serviceAgreementMap: ServiceAgreementMap, includedOptionalServiceIds: string[] }) => any

export const { Provider: ProposalSectionServicesStoreProvider, useProvidedStore: useProposalSectionServicesStore } =
   createStoreContext(ProposalSectionServicesStore)